function playTile(t) {
  const out = { code: t.code }
  if (t.rotated) out.rotated = true
  if (t.highlight) out.highlight = true
  return out
}

function playOpponent(p) {
  return {
    name: p.name,
    wind: p.wind,
    score: p.score,
    riichi: p.riichi,
    discards: p.discards.map(playTile),
  }
}

export function toPlayFrames(editorFrames) {
  return editorFrames.map((f) => {
    const hero = f.seats.hero
    const held = hero.hand.slice(0, 13)
    const hl = held.filter((t) => t.highlight).map((t) => t.code)
    const hasDraw = hero.hand.length > 13
    const drawn = hasDraw ? hero.hand[hero.hand.length - 1] : null

    const heroOut = {
      score: hero.score,
      riichi: hero.riichi,
      hand: held.map((t) => t.code),
      discards: hero.discards.map(playTile),
      draw: hasDraw ? drawn.code : null,
    }
    if (hl.length) heroOut.hl = hl
    if (hasDraw && drawn.highlight) heroOut.drawHl = true

    return {
      round: f.round,
      wall: f.wall,
      honba: f.honba,
      sticks: f.sticks,
      doraInd: f.doraInd,
      title: f.title,
      body: f.body,
      ukeire: f.ukeire ?? null,
      win: !!f.win,
      turn: f.turn ?? null,
      hero: heroOut,
      left: playOpponent(f.seats.left),
      top: playOpponent(f.seats.top),
      right: playOpponent(f.seats.right),
    }
  })
}
